import React from 'react';

// Define the entity details context
export const EntityCreateContext = React.createContext(null);
